// eslint-disable-next-line @nx/enforce-module-boundaries
import { MediaPage } from '@insurance/features/staff/pages'
import { useParams } from 'react-router-dom'

export const MediaStaffPage = () => {
  const { id } = useParams()

  if (!id) return null

  return <MediaPage brokerId={id} />
}
